import { render, staticRenderFns } from "./RestrictedCaseDetails.vue?vue&type=template&id=35a60924&scoped=true&"
import script from "./RestrictedCaseDetails.vue?vue&type=script&lang=ts&"
export * from "./RestrictedCaseDetails.vue?vue&type=script&lang=ts&"
import style0 from "./RestrictedCaseDetails.vue?vue&type=style&index=0&id=35a60924&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a60924",
  null
  
)

export default component.exports